import * as Yup from "yup";

export * from "yup";

export * from "../../common/validators.js";

export const id = Yup.string().trim();
